import { ApplicationSectionKeys } from 'src/app/constants/app.constants';
import { AllDropdownKeys } from 'src/app/jurisdiction/jurisdiction.constants';
import { CustomFieldType } from 'src/app/+shared/custom-fields/models/enums/customFieldType';

const specialApplianceDropDown = {
  name: 'specialApplianceDropDown',
  label: 'facilities-data.form-fields.special-appliance-water',
  section: ApplicationSectionKeys.technicalData.waterDevice,
  type: CustomFieldType.Dropdown,
  dropdownTypeKey: AllDropdownKeys.TappingPointType,
};

const amount = {
  name: 'amount',
  label: 'facilities-data.form-fields.amount',
  section: ApplicationSectionKeys.technicalData.waterDevice,
  type: CustomFieldType.Number,
};

const vrCold = {
  name: 'vrCold',
  label: 'facilities-data.form-fields.vr_cold',
  section: ApplicationSectionKeys.technicalData.waterDevice,
  type: CustomFieldType.Number,
};

const vrHot = {
  name: 'vrHot',
  label: 'facilities-data.form-fields.vr_hot',
  section: ApplicationSectionKeys.technicalData.waterDevice,
  type: CustomFieldType.Number,
};

export default {
  specialApplianceDropDown,
  amount,
  vrCold,
  vrHot,
};
